import axiosClient from "../api/axiosClient";

// Chat media approval: opt-in per-event gate (ChatRoom.RequireMediaApproval).
// While on, a fresh "image"/"video" chat message from anyone not already
// trusted in that room's ChatRoomUserMediaTrust is held Pending instead of
// broadcasting — see ChatHub.SendMessage / ChatMediaApprovalService on the
// backend. All four calls below map 1:1 to ChatController's
// "Chat Media Approval" region (the Message/-suffixed endpoints — this panel
// only ever sends/reviews live chat messages, not the separate
// ChatRoomGallery/album feature the Gallery/-suffixed endpoints gate).

export const setChatRoomMediaApproval = (chatRoomId, requireMediaApproval) =>
  axiosClient.post(`/Chat/Room/${chatRoomId}/MediaApprovalSetting`, {
    RequireMediaApproval: requireMediaApproval,
  });

export const getPendingChatMessages = (chatRoomId, pageNumber = 1, pageSize = 20) =>
  axiosClient.get(`/Chat/Room/${chatRoomId}/Messages/PendingApproval`, {
    params: { pageNumber, pageSize },
  });

export const approveChatMessage = (messageId, applyToFutureUploads = false) =>
  axiosClient.post(`/Chat/Message/${messageId}/Approve`, {
    ApplyToFutureUploads: applyToFutureUploads,
  });

export const rejectChatMessage = (messageId, reason, applyToFutureUploads = false) =>
  axiosClient.post(`/Chat/Message/${messageId}/Reject`, {
    Reason: reason || null,
    ApplyToFutureUploads: applyToFutureUploads,
  });
